/** R$ 1.234,56 em pt-BR. */
export const fmtMoney = (v) =>
  "R$ " + (Number(v) || 0).toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

/**
 * Formata telefone BR cobrindo 4 layouts: 10, 11, 12 (com DDI 55, 8 dígitos)
 * e 13 (com DDI 55, 9 dígitos). Saída no formato (XX)X.XXXX-XXXX ou
 * (XX)XXXX-XXXX. Strings inválidas retornam o valor original.
 */
export function formatPhoneNumber(phone) {
  if (!phone) return "";
  const digits = phone.replace(/\D/g, "");
  if (digits.length === 13) {
    return `(${digits.slice(2, 4)})${digits[4]}.${digits.slice(5, 9)}-${digits.slice(9)}`;
  } else if (digits.length === 12) {
    return `(${digits.slice(2, 4)})${digits.slice(4, 8)}-${digits.slice(8)}`;
  } else if (digits.length === 11) {
    return `(${digits.slice(0, 2)})${digits[2]}.${digits.slice(3, 7)}-${digits.slice(7)}`;
  } else if (digits.length === 10) {
    return `(${digits.slice(0, 2)})${digits.slice(2, 6)}-${digits.slice(6)}`;
  }
  return phone;
}

/** dd/mm/aaaa HH:MM:SS em pt-BR. */
export function formatDateTime(dateStr) {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  return (
    date.toLocaleDateString("pt-BR") + " " +
    date.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit", second: "2-digit" })
  );
}

/** Tempo de etapa em "X min Y s" / "X min" / "Y s". */
export function formatTempoEtapa(seg) {
  if (seg == null || seg === undefined) return "—";
  const m = Math.floor(seg / 60);
  const s = Math.floor(seg % 60);
  if (m === 0) return s === 0 ? "0 s" : `${s} s`;
  if (s === 0) return `${m} min`;
  return `${m} min ${s} s`;
}

/** Diferença entre abertura e fechamento (mesa/balcão) em "X min" / "Xh Ymin". */
export function formatPermanencia(openedAt, closedAt) {
  if (!openedAt || !closedAt) return "—";
  const min = (new Date(closedAt) - new Date(openedAt)) / 60000;
  if (min < 1) return "< 1 min";
  if (min < 60) return `${Math.round(min)} min`;
  const h = Math.floor(min / 60);
  const m = Math.round(min % 60);
  return m > 0 ? `${h}h ${m}min` : `${h}h`;
}
